import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';

function VisaPrepUniEnrolmentStep2(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.QUALIFICATION_AS_PROOF_OF_ENGLISH}
        label={'Are you using a previous qualification as proof of English language?'}
        value={boolToYesNo(props.qualificationAsProofOfEnglish)}
      />
      {props.qualificationAsProofOfEnglish ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.QUALIFICATION_AND_COUNTRY}
          value={props.qualificationAndCountry}
          label={'Qualification and country'}
          fullLabel={'Please state your academic qualification and the country it was taught in:'}
        />
      ) : null}
    </>
  );
}

export default VisaPrepUniEnrolmentStep2;
